import React, { useCallback } from "react";
import { ArrowRightIcon, Body1, Body2, Paper } from "@activecollab/components";
import PropTypes from "prop-types";
import { assets_url } from "~/utils/urls";

export const OptionCard = ({ option, setStep }) => {
  const handleClick = useCallback(() => {
    setStep(option.step);
  }, [option.step, setStep]);
  return (
    <Paper
      type="tile-2"
      className="tw-flex tw-items-center tw-min-h-24 tw-py-4 tw-px-2 tw-gap-6 tw-cursor-pointer tw-min-w-[200px] tw-w-full"
      onClick={handleClick}
    >
      <img
        alt={option.title}
        src={`${assets_url}${option.img}`}
        className="tw-w-12 tw-h-12 sm:tw-w-16 sm:tw-h-16"
      />
      <div className="tw-flex tw-min-h-16 tw-flex-col tw-min-w-[150px] tw-w-full">
        <Body1 weight="bold">{option.title}</Body1>
        <Body2
          color="secondary"
          weight="regular"
          letterSpacing="regular"
          lineHeight="regular"
        >
          {option.description}
        </Body2>
      </div>
      <div className="tw-hidden tw-justify-center tw-items-center sm:tw-block">
        <ArrowRightIcon className="tw-shrink-0" />
      </div>
    </Paper>
  );
};

OptionCard.propTypes = {
  option: PropTypes.object,
  setStep: PropTypes.func,
};
